// extracted by mini-css-extract-plugin
module.exports = {"short-link-container":"ShortLink_short-link-container__2N9pp","short-link-error":"ShortLink_short-link-error__1Qfi2"};